import { connect } from 'react-redux';
import { SortType } from 'services/store';
import { tagGetList, updateFilters } from 'services/store/tags/actions';
import MobileFiltersDrawer from './MobileFiltersDrawer';
// @ts-ignore
const mapStateToProps = ({ tags }) => ({ tagStore: tags });

// @ts-ignore
const mapDispatchToProps = (dispatch) => ({
  // @ts-ignore
  getTagList: (tagType): void => {
    dispatch(tagGetList({ tagType }));
  },
  updateFilters: (appliedFilters: {
    minDuration: number | null | undefined;
    maxDuration: number | null | undefined;
    sortBy: Array<SortType>;
  }): void => {
    dispatch(updateFilters(appliedFilters));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MobileFiltersDrawer);
